import { jsx } from 'react/jsx-runtime';
import { forwardRef, useMemo, createElement } from 'react';
import { Legacy_Dropdown } from '../../../legacy-dropdown/Dropdown.mjs';
import { useSelectSearchContext, Collection } from '../context.mjs';

const SelectSubMenuTrigger = forwardRef((props, ref) => {
  const {
    children,
    textValue = "",
    disabled = false,
    hidden: hiddenFromProps,
    ...submenuTriggerItemProps
  } = props;
  const { searchValue } = useSelectSearchContext();
  const hidden = useMemo(() => {
    const hiddenFromContext = searchValue !== "" && !textValue.includes(searchValue);
    return hiddenFromProps ?? hiddenFromContext;
  }, [hiddenFromProps, textValue, searchValue]);
  return /* @__PURE__ */ jsx(
    Collection.ItemSlot,
    {
      value: textValue,
      disabled,
      scope: void 0,
      children: /* @__PURE__ */ createElement(
        Legacy_Dropdown.SubTrigger,
        {
          ...submenuTriggerItemProps,
          key: searchValue,
          ref,
          hidden
        },
        children
      )
    }
  );
});

export { SelectSubMenuTrigger };
//# sourceMappingURL=SubMenuTrigger.mjs.map
